import { render, staticRenderFns } from "./ImportToMongoButton.vue?vue&type=template&id=6c07a050"
import script from "./ImportToMongoButton.vue?vue&type=script&lang=ts"
export * from "./ImportToMongoButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports